import { Button, Modal } from 'react-bootstrap';
import { useUserContext } from '@state/userContext';
import { buildLoginUrl } from '@utils/LoginUtils';

function AuthFailedModal() {
  const { loggedIn } = useUserContext();

  const goToLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const redirectPath =
      params.get('redirectUrl') ||
      (window.location.pathname !== '/login'
        ? window.location.pathname + window.location.search
        : null);
    window.location.href = buildLoginUrl(redirectPath);
  };

  return (
    <Modal show={!loggedIn} centered>
      <Modal.Header style={{ justifyContent: 'center' }}>
        <Modal.Title>You have been logged out.</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        Your session has expired. Please log in again to continue.
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'center' }}>
        <Button variant="primary" onClick={goToLogin}>
          GO TO LOGIN
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AuthFailedModal;
